import React, { useState } from 'react';
import StarRating  from './StarRating.jsx';

const Review = ({ review }) => (
  <div className="border-b border-gray-200 py-4">
    <div className="flex justify-between items-center mb-2">
      <span className="font-bold">{review.username}</span>
      <span className="text-sm text-gray-500">{new Date(review.date).toLocaleDateString()}</span>
    </div>
    <div className="mb-2">
      <StarRating rating={review.rating} onRatingChange={() => {}} />
    </div>
    <p>{review.comment}</p>
  </div>
);

const ReviewForm = ({ onSubmit, onClose }) => {
  const [newReview, setNewReview] = useState({
    username: '',
    rating: 0,
    comment: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(newReview);
    onClose();
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4">Write a Review</h2>
      <div className="mb-4">
        <label className="block mb-2">Username:</label>
        <input
          type="text"
          value={newReview.username}
          onChange={(e) => setNewReview({...newReview, username: e.target.value})}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block mb-2">Rating:</label>
        <StarRating
          rating={newReview.rating}
          onRatingChange={(rating) => setNewReview({...newReview, rating})}
        />
      </div>
      <div className="mb-4">
        <label className="block mb-2">Review:</label>
        <textarea
          value={newReview.comment}
          onChange={(e) => setNewReview({...newReview, comment: e.target.value})}
          className="w-full p-2 border rounded"
          rows="4"
          required
        />
      </div>
      <div className="flex justify-end space-x-2">
        <button type="button" onClick={onClose} className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400">
          Cancel
        </button>
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
            Send Review
        </button>
      </div>
    </form>
  );
};

export const ReviewSection = ({ productId, initialReviews = [] }) => {
  const [reviews, setReviews] = useState(initialReviews);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSubmit = (newReview) => {
    const review = {
      ...newReview,
      date: new Date().toISOString(),
      id: Date.now()
    };
    setReviews([review, ...reviews]);
    // Here you can add logic to send the review to the server
  };

  return (
    <div className="mt-8">
      <div className="flex justify-center items-center mb-4">
          {/* <h2 className="text-2xl font-bold">ביקורות</h2> */}
        <button 
          onClick={() => setIsModalOpen(true)}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Write a Review
        </button>
      </div>
      
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="w-2/3 h-2/3 bg-white rounded-lg overflow-auto">
            <ReviewForm onSubmit={handleSubmit} onClose={() => setIsModalOpen(false)} />
          </div>
        </div>
      )}

      <div>
        {reviews.map((review) => (
          <Review key={review.id} review={review} />
        ))}
      </div>
    </div>
  );
};